export default{
    LOCIZE:{
        PROJECT_ID: '07028ea3-2c7f-4753-b8eb-2a73da59d1c5',
        API_KEY: '57b8337b-a976-454b-8901-b0c9c3bfbf12',
        NAMESPACE: 'translation',
        LANGUAGE:{
            ENGLISH_GB: 'en-GB',
            ENGLISH_US: 'en-US',
            DUTCH: 'nl-NL',
            GERMAN: 'de-DE'
        }
    },
    STRIPE:{
        PUBLISH_KEY_DEV: 'pk_test_t7PO52nTc3U3xRZeNMl1U7dA',
        PUBLISH_KEY_STAGING: 'pk_test_Rc9twCh2VIQ79fQSdh1b8wba',
        PUBLISH_KEY_PROD: 'pk_live_IGGNbXTx1Xah7TJFXbt65nP0'
    },
    URL:{
        API:{
            DEV:'https://api-dev.accura.onl',
            PROD: 'https://api.accura.onl',
            STAGING: 'https://api-staging.accura.onl'
        },
        WEB:{
            DEV:'https://web-dev.accura.onl',
            PROD: 'https://www.accura.onl',
            STAGING: 'https://web-staging.accura.onl'
        }
    },
    ENV:{
        PRODUCTION: 'production',
        DEVELOPMENT: 'development',
        STAGING: 'staging'
    },
    KEYS: {
        accounts: {
            development: {key: 'xKEghJoUWTa9EBcLSBXUG2NpDeRHejjJ8PU2XPzm'},
            production: {key: 'IKqniIkMSYaMvYE1uZKvj6aoxNLmIGQL3xecXJlp'},
            staging: {key: 'OYkuBb3QbO7UFrmLFordbcmImDu2tU36It6alDqe'}
        },
        content: {
            development: {key: 'Y1sOrOz0Pc97Aip5pniHI2ntyIrDY6Ow9r1rHMSE'},
            production: {key: 'UwuPCNMFqBatpmtMM4pit3jZdsWnbCwS4FVboz3E'},
            staging: {key: '1u4CvSKhDt4rzbEZ9tlJo7rKriqoD2al441u50Gi'}
        },
        curate: {
            development: {key: 'dXlGjl3VG07SVhub0Moh21l4N53Mf84E4BRPKerZ'},
            production: {key: 'TWzSSQbjDq3tHvQCW9YT288EGhGXxJgm63eYKT88'},
            staging: {key: 'WnSqtJfi6b2Tldgwo0qVH6QKSC5KoNRY4ftUPJT9'}
        },
        collection: {
            development: {key: 'MiUDx7BJvA7z2VTFqzihe1SMzusXUrsuazVKpNCO'},
            production: {key: '4CnDEFBhhf7aN9G4K3isN4PzOGwYWW5O81BeePhI'},
            staging: {key: 'T1EUXmBC3J5FDeqrk7XaL5J8DSHWuv7J2rgDgts0'}
        },
        pocket: {
            development: {key: 'ZJjw1wg2Vs1kvSsE1DkM31txULgsdZdE6vHJ8nPP'},
            production: {key: 'HzdZvCZgagavZX1SUJlpL9JQWIJYwNFT7SVKaSyD'},
            staging: {key: 'MLwGR2j8Ak7TOqb8Gwi9W2YQ1QoGeQbp3c6z5gDv'}
        },
        payments: {
            development: {key: 'ZhWKTP83Bi1QyjoV4ZFky4320iv6OQ2H5PUnEwQP'},
            production: {key: 'd7ic41kDl246CfHHwQzT88zv5XNet3CE9en5DHGB'},
            staging: {key: '2r0tfmHX3saD9Gr1rJ5KhaYiBecnjwe7YymV3p7e'}
        },
        ip: {
            development: {key: 'EYbg2I9IID61Tb89VIHLm9naL9CbpafM9nRKjJjr'},
            staging: {key: 'K8XQSdAYJdaw5RQccj8dSl9e13kGYD39xSPYpUZ4'},
            production: {key: 'DvCzpgvTLA8F2OFzI9bljU6paAAGggx4y9C3gwn3'}
        },
        admin: {
            development: {key: 'XTKaBYOYkZ7Qn4uH3IvMW2J5bojbPynY5AMszJYM'},
            staging: {key: 'wluxG45hLn2lrb15xqXXe728CaMVQyCT4yGBynbr'},
            production: {key: '5NZIfT9UZM480yWKjCkot2e6rBIP2sdva5LfK83k'}
        },
        user: {
            development: {key: "qU6LLowxbw8QLmSQ7IW0e1rXc3hbawE1YC4Mo5xg"},
            staging: {key: 'PKDXQMm6bB7mU1VlitjR7FAp4mrwo8R1RzDxZIx2'},
            production: {key: 'ysxgeGtDjLKRPTt9wqsb11pAE9o7RgM4rbg1qhh6'}
        },
        admin_ext: {
            development: {key: "a4F3QaRI8e3rggF5pQxdX13Mq2NkitI1ajsN6KMm"},
            staging: {key: 'rmPHnMGtk8aY0ku30popx7ajfbl52s1X5JXUBZDr'},
            production: {key: 'XmDtF0YgxS8YbRT0dFfwc7W74kiejbA1aOxxS5FQ'}
        },
        'admin-curate': {
            development: {key: "QzTpunqSNM8fm3gbt4BAa40OssfyfIPH4EvjMmJa"},
            staging: {key: 'nwCD82aIBI53IAnWE4vVk4QgDYo5Ibjx6tTKZFjN'},
            production: {key: 'koRJTf6DJY4RBvNZRMR5P1r0d6Iqe6co7XqBuKO2'}
        },
        insight: {
            development: {key: 'zax84S9XFa6szJkDqsgc45g3J4bBPH9t4YN5qv0R'},
            staging: {key: 'rgV6T2mBJY61flw4SuVts8HMHVi7IKhU7eFWrBg4'},
            production: {key: 'to0OAiDb0AlOVT6gX2Oi14Pf0GMVwuu5mw9iN1Uf'}
        },
        twitter: {
            development: {key: 'hsEdfWOKog8mtt46Ij2el1J74sznISwF6q0Z0rzx'},
            production: {key: 'o1YkEsSSps7dOCF2yunaZ3byOikvAq3E9o99dD8w'},
            staging: {key: 'zeMa5rB0cB4qxP3Mwow013PJWm5djfHT3mQsXXa1'}
        },
        'curate-ext': {
            development: {key: '5ZBugrbtrtGwzqvMFNFa6TAf16yx6gi2URMxZk3e'},
            staging: {key: 'Fc6Y3c4h6OanyA6VNXD58ZlV2mEgAZ49txCwzFj5'},
            production: {key: '25Qvr6fcRM17FxrH2KMCM1oZ4ncwJqZ32DO8sDlp'}
        },
        facebook: {
            development: {key: '2XUO38Jm7044IRA1ezOUD2OkiIUlAbse26YUAwjV'},
            staging: {key: 'kL9e3OAigg9ceb9H0pT8E5FNbpl9ncio7U1HQGlU'},
            production: {key: '04FZj2DBxl4TM9ShPkaJba6lHxbxI4zY1a5lZ8E5'}
        },
        short_url: {
            development: {key: 'aO1t0gvnpja2oJXfC9zcz3zXxAVwdow27PbSphhA'},
            staging: {key: 'XmMjkgys713rol5sIuJQbuCHezrajTh5yxeS9Eqf'},
            production: {key: 'j35HGOOgDq66WZWlESvxe2H6fkNgeoTe48a4qpTh'}
        },
        am: {
            development: {key: '7IeCHwz3lG8DYKlMlwrtJ8JYJfnBmgzqao9mHEAg'},
            staging: {key: 'pUXj6xh57e1cvokAc4uBi4vyFi0IXweg2JEEpH3L'},
            production: {key: '6HxzAJW5fu7HwcRVdOeKs4v9CkUEtX2hCIQZxUnc'}
        },
        pb: {
            development: {key: 'KMnPuIoLVr5eL72ciVEvpyX9iO2mrY55Vo7ZDLC6'},
            staging: {key: 'p84fjBgre27UfpXWL5gEcvTFzWQMQPYaRy8PQDD8'},
            production: {key: 'Ewq14DeH4P6cPzJqruJxr5FcvR6jIRica8LO2iIc'}
        },
        au: {
            development: {key: 'e2VKyPoEvv2vlzmKvhFpJ7a9aknLrFnK6mnHN0Q3'},
            staging: {key: 'QXsVR7KzPK6Lj0uEPCFA44ZSZUMdD9Or2WankMnD'},
            production: {key: 'QPFM4mNnkt9ucPKSmDanL7ZQY0BCueY060fSY6aK'}
        },
        pr: {
            development: {key: 'TEx08tVR7j1MacdTGqPUp4Uzw0BY0rUT9dh8PDic'},
            staging: {key: '7koUeDgrkj7Y1ySeleLnY9ipTlWVgMnX6RmP8qf5'},
            production: {key: '3MaF0ue0J64EwOlyTbkT120hBLuzOUZ39vRnZxWw'}
        },
        social: {
            development: {key: 'g63s8Z1SAj4pnTtM8XBOy2OHHdcd7nWH9upk1htv'},
            staging: {key: '2nGXP22LSW644faQT1CbS6uvHVBEzOoA2vGHkjru'},
            production: {key: 'cpd71O6zcJ58mFlXVCrms1LmVBIv2mrJqWf6L7xb'}
        },
        dossier: {
            development: {key: 'wlLPJwQeVb6MOHgilh1a07Bmef2QCDMJ9qB8UJ57'},
            staging: {key: 'vIBsC0r2XI4d3pkzMWJyN5oLYOjqOe3MaFn0gDQd'},
            production: {key: 'ANxGn37L2l5z6NQt9k8w33HJe10KOXn5upDtCKbc'}
        },
        newsroom: {
            development: {key: 'yreGOV8rqs8ulVhbpnyLa8j0KM32EEx8p1ZzJjB1'},
            staging: {key: '2gC7Vdjnzt7wMJfPVtqwW2xEumaa8Iu04Gvb8biJ'},
            production: {key: 'RInoL9nfl71sxx76gxoM45uyPxsGZIE38Q2Rvi9P'}
        },
        tp: {
            development: {key: 'hM1qVepidQ330YvqjyluO3jLfGctW4s961PLzhpA'},
            staging: {key: 'vcvGy67mFJabnqitSVr1m4bPxw82uOc05wMKrtU9'},
            production: {key: 'muDQmwrQCx3u9IZtJLugK91bVQt5XKm95Ep95Orq'}
        },
        org: {
            development: {key: 'LQgWBCXoKT4XbPJbTtX5J7Lus6SdsFAn1LesMzD7'},
            staging: {key: 'TqW0XjkcdD2m6xlChrADu4h029F8T5Di8U8MchAG'},
            production: {key: 'NAgRkPeum986NtF5yX5NS3tD9ZSVnKCJ4A594QHe'}
        },
        team: {
            development: {key: '87oGwFGRsV1e2iA9NsifF7IFb4rknycy8llPWC0j'},
            staging: {key: 'dtrC6jyuI47Z9lfV4Ur638GEK1hfZ4rxYYF98Noe'},
            production: {key: 'Xg8V0sf9yraPbgPkZKVqu7fdV42cR7kq9NHcw3LS'}
        },
        people: {
            development: {key: 'iRmVBw4FIVjjXr4afvCP43BKsH9orHF9OpYXDKsi'},
            staging: {key: 'mlFFphLk2WaWnfJqUv9Wi4wP6c52m3R49ayWRVfD'},
            production: {key: 'qMhRwa5fSn2KTMP3sX46x5p9isCAlH5a5k9hk5hM'}
        },
        'org-billing': {
            development: {key: 'F63cWpZuN67tUswYnDe9i7qOWfvcp2XP2aoHy6IF'},
            staging: {key: 'c0hEYYiI3b7wnwDTQ2vTueB7ytSJ38m4yDP8tml5'},
            production: {key: 'ofBwXE1hmK9j2eX2t7ac144YKV3RrN9u8UMBPgIE'}
        },
        donation: {
            development: {key: 'e30l3QZ0hm6PXhp2k6XgR9Wv962rSckV8ywGUQEZ'},
            staging: {key: 'HksGnAsQ1c4H3iKouFDeJ6R3atLEfZ3Z5E9NYABq'},
            production: {key: 'rr0C4JuGzsxxmQ9Sbt5l9FZc691UI9h9Ch9XBNg7'}
        },
        'donation-ext': {
            development: {key: 'eln5HBlfca4umInVZvsWS62qNR9LQLL79xkoDE4c'},
            staging: {key: 'AZeqHvb0hk6Q3vus0H5dT4G8cYf3Sjyx5yg3TPdw'},
            production: {key: 'olrZsnXV48a5tKjLgRz873BaHr8aK8XeONKlgT2b'}
        },
        collab: {
            development: {key: 'DPh3sj8z6Y9swtXHPMaOJ0l14VduBCK9IeCNTYnj'},
            staging: {key: 'uFBOlNJPpG2zvXss0h43U7vfH6doVAhQ37bWmtjd'},
            production: {key: 'knX0VqApjh4HvwC6bD9t11BQcjuwehiu5Huw0r6p'}
        },
        'team-ext': {
            development: {key: 'NvBcboRt0NGrTCXUEjfK2zGQ5lF1AW39PO6edLHa'},
            staging: {key: 'nNfNoKmfgR5OkjCeA0BVY8nAZdcf7EamaCOfunz3'},
            production: {key: '0IlFWTjhGI1OkkkBhVKjD7IIOhtEpxj8Erl8dUO5'}
        },
        'org-per': {
            development: {key: 'xbAgPtpMyO7584GGPKdut14q4VZF0BkKaQWRm9fa'},
            staging: {key: 'yNNdxSQvVY7oBJBA8iliN1DzzdUJ9PZ11Ystjy7u'},
            production: {key: 'n2nHJ0UWg49G0San6NzjCaiR9ah8ZK7j5J1StKe5'}
        },
        domain: {
            development: {key: '11Pf3w3lb42jgBuYiqLL27xkdSnuZZhT2PWBkUeT'},
            staging: {key: 'RgalZCoRLI2ZvdZPd4g0j4gT0MBPZLuv5xpCsZ11'},
            production: {key: 'ScExVKcBRuHxvvihjz0O9n2lf32gefW14yqgAs50'}
        },
        loc: {
            development: {key: '9euRe5PEEg83Pi3HcSNMj3plOrTQARuC5ukBX3Uh'},
            staging: {key: 'VBzqwY0O0Qa1U8iTGbbRIaGyjeEaxqNs2wc7L6ST'},
            production: {key: 'R5HtQ56bFx3UP3IrlxFmp2HmMdl0PpRr3noYOtOY'}
        },
        "org-lic": {
            development: {key: 'GupPlk1PH868zzQdXhQ6d469r6Bjnr7Y7Ff0ozzF'},
            staging: {key: 'o2fYAHaqfz9lke9Esmlzl6495vI9M1dI1xSyfxUn'},
            production: {key: 'WUaGfwCSmeaqXbULRTkH9aY2QTnCGFlz4JzLiBLm'}
        },
        iam:{
            development: {key: 'Ua4BDnDHpv3WNBI4FkQjb2mbKb4ht3JX8EUHM30t'},
            staging: {key: 'OfRbjuL72i86zzhqNeuma7ehZLtdqX4B6n9SoH2M'},
            production: {key: 'URoEHw4SBY2spFYSYUTiF1oo91T7ePgA4iMfZAfl'}
        },
        "iam-policy": {
            development: {key: 'QRSPZoAeLg48ok0H8dTfB7jdIa6UCzzz6BJsf2iv'},
            staging: {key: 'XdqzQr5RHdVlz30iPCJ55dmz6HndjwI659dsCEwi'},
            production: {key: 'ytqWpfiksD1jdejpNOYIQLHkrqC8fw2nfrkMQGf0'}
        },
        editor: {
            development: {key: 'wQxJT3imH7797nfYEGF9S8pHZEJoqiKe7rRqSc9c'},
            staging: {key: 'h0esn1JLee7k7NG37WybX5gCOt7N4v8B5c0soE2M'},
            production: {key: 'eCiFChJfOm8HGhxNMBjsp4lFS88Oda3j7Sz2x7WB'}
        },
        "editor-projects": {
            development: {key: 'pWLg52Zykg1d5mO2Iak9M8JVHqHkrGwZ8xcCYCwo'},
            staging: {key: '6Jagpy5fM9arVRfJPvzUN6gKQfpT7G1e3teNbapZ'},
            production: {key: 'bh68jGBq9Pacb3PcMvVeo8TJWNcwezaT2BRUfmLa'}
        }
    },
    FACEBOOK_APP_ID: 656828628114230
}